import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';
import { Icon } from '../../ui_elements';
import { colors } from '../../styles/theme';
import FloatingContainer from '../../containers/FloatingContainer';

const InnerButton = styled.div`
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  cursor: pointer;
  ${(props) =>
    props.enabled
      ? css`
          background-color: ${colors.orange.primary};
        `
      : css`
          background-color: ${colors.grey.secondaryDark};
        `}
  ${(props) =>
    props.enabled
      ? css`
          border: 1px solid ${colors.orange.darkest};
        `
      : css`
          border: 1px solid ${colors.grey.secondaryDark};
        `}

  &:hover {
    ${(props) =>
      props.enabled
        ? css`
            background-color: ${colors.orange.darkest};
          `
        : null}
  }
`;

const StyledIcon = styled(Icon)`
  margin: 0 1px;
`;

const FloatingButtonContainer = styled(FloatingContainer)`
  width: 70px;
  ::before {
    top: 25px;
    left: -22px;
    border-width: 11px;
  }

  ::after {
    left: -22px;
  }

  .button-container {
    padding: 10px;
    -webkit-box-shadow: 0 0 1px 1px ${colors.grey.secondaryDark}, 0 1px 2px 0 ${colors.grey.secondary};
    box-shadow: 0 0 1px 1px ${colors.grey.secondaryDark}, 0 1px 2px 0 ${colors.grey.secondary};
    ::after {
      border-right-color: ${colors.grey.secondaryLight};
    }
  }
`;

export default function NewCommentButton({ enabled, onClick }) {
  return (
    <InnerButton enabled={enabled} onClick={enabled ? onClick : () => {}}>
      <StyledIcon type="plus" color="white" />
      <StyledIcon type="comment" color="white" />
    </InnerButton>
  );
}

const commentButtonDefaults = {
  enabled: true,
};

const commentButtonProps = {
  enabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

NewCommentButton.defaultProps = commentButtonDefaults;
NewCommentButton.propTypes = commentButtonProps;

export function FloatingCommentButton(props) {
  const { top, right, left, borderColor } = props;

  return (
    <FloatingButtonContainer
      top={top}
      left={left}
      right={right}
      borderColor={borderColor}
      backgroundColor={colors.white}
      className="button-container"
      commentBtn={true}
    >
      <NewCommentButton {...props} />
    </FloatingButtonContainer>
  );
}

FloatingCommentButton.defaultProps = {
  ...commentButtonDefaults,
  top: null,
  right: null,
  left: null,
};

FloatingCommentButton.propTypes = {
  ...commentButtonProps,
  top: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.oneOf([null])]),
  left: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.oneOf([null])]),
  right: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.oneOf([null])]),
};
